import { MenuItem } from '@szhsin/react-menu';
import React from 'react';
import { useState } from 'react';

const FontSize = () => {
  const [fontSize, changeFontSize] = useState(16);

  const updateFontSize = (e) => {
    const fontSize = e.target.value;
    const contentCss = document.querySelector(":root");

    contentCss.style.fontSize = `${fontSize}px`;
    changeFontSize(fontSize);
  };

  return (<MenuItem>
    <label>Font Size</label>
    <input
      className="font-sizer"
      value={fontSize}
      type="number"
      onChange={e => updateFontSize(e) }/>
  </MenuItem>);
};

export default FontSize;
